import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useExpressCheckoutSection} from '../hooks/useGetBasketPageSection';
import {ExpressCheckoutView} from './ExpressCheckoutView';

export const ExpressCheckout = ({basketTotal}: {basketTotal: number}) => {
  return (
    <DataFetcher
      // as this data fetcher is used inside of a view, we need to disable the request in order to not fire two requests
      request={useExpressCheckoutSection(true)}
      Error={null}
      View={ExpressCheckoutView}
      Loading={() => null}
      viewProps={{basketTotal}}
    />
  );
};
